import Select from "../../../ui_components/Select/Select";
import React, {useEffect, useState} from 'react';
import {useI18nContext} from '../../../contexts/I18nContext';
import SelectOption from "../../../ui_components/Select/SelectOption";
import PaymentMethodSelectProperties from './PaymentMethodSelectProperties';
import CreditCardSharpIcon from '@mui/icons-material/CreditCardSharp';
import PaymentsSharpIcon from '@mui/icons-material/PaymentsSharp';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentMethod from "../../../entities/PaymentMethod";
import CheckPaymentIcon from "../../../ui_components/Icon/icons/CheckPaymentIcon";
import CashPaymentIcon from "../../../ui_components/Icon/icons/CashPaymentIcon";
import WireTransferIcon from "../../../ui_components/Icon/icons/WireTransferIcon";
import ZelleIcon from "../../../ui_components/Icon/icons/ZelleIcon";
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';

const PaymentMethodSelect: React.FC<PaymentMethodSelectProperties> = ({
    selected,
    onChange,
    disabled,
    fullWidth = false,
    className = ''
}) => {
    const i18n = useI18nContext();

    const [options, setOptions] = useState<SelectOption[]>([]);
    const [selectedOption, setSelectedOption] = useState<SelectOption>();

    const getIcon = (paymentType: PaymentMethod) => {
        switch (paymentType) {
            case PaymentMethod.CASH:
                return CashPaymentIcon;
            case PaymentMethod.ZELLE:
                return ZelleIcon;
            case PaymentMethod.BANK_TRANSFER:
                return WireTransferIcon;
            case PaymentMethod.DEBIT_CARD:
                return CreditCardSharpIcon;
            case PaymentMethod.CREDIT_CARD:
                return CreditCardIcon;
            case PaymentMethod.CHECK:
                return CheckPaymentIcon;
            case PaymentMethod.OTHER:
                return PermPhoneMsgIcon;
        }
    }

    useEffect(() => {
        const paymentMethods = Object.values(PaymentMethod);
        const mappedPaymentMethods = paymentMethods.map(paymentType => {
            return new SelectOption(
                i18n.translate(`PAYMENT_TYPE_${paymentType}`),
                paymentType,
                undefined,
                getIcon(paymentType)
            );
        });
        setOptions(mappedPaymentMethods);
    }, [i18n]);

    useEffect(() => {
        const selectedOption = options.find(t => t.value === selected);
        setSelectedOption(selectedOption);
    }, [selected, options]);

    const onStatusChange = (option: SelectOption) => {
        const paymentType = option.value as PaymentMethod;
        onChange(paymentType);
    }

    return (
        <Select
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={i18n.translate("PAYMENT_TYPE_FILTER")}
            placeholder={i18n.translate("PAYMENT_TYPE_FILTER_PLACEHOLDER")}
            selected={selectedOption}
            icon={PaymentsSharpIcon}
            onChange={onStatusChange}
            elements={options}
        />
    )
}

export default PaymentMethodSelect;